import * as React from "react";
const SvgFiRrLeaderboardTrophy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaderboard-trophy_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-3-1a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1m-8.665-7H11v.725C11 13.058 9.778 13 9.778 13S9 13.448 9 14a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1c0-.552-.778-1-.778-1S13 13.058 13 11.725V11h.664c2.548 0 4.503-1.258 5.229-3.366a1.98 1.98 0 0 0-.264-1.787A2.02 2.02 0 0 0 16.988 5H15.98a.895.895 0 0 0-.891-1H8.912a.894.894 0 0 0-.891 1H7.013c-.649 0-1.263.317-1.641.847a1.98 1.98 0 0 0-.263 1.787C5.835 9.742 7.789 11 10.337 11zm6.667-4.018C16.561 8.264 15.344 9 13.664 9h-.262a2.3 2.3 0 0 1 .492-.506c.566-.412.999-.939 1.335-1.502zM8.776 7c.335.56.767 1.084 1.33 1.494.195.142.353.317.492.506h-.262C8.657 9 7.44 8.265 7.012 7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaderboard-trophy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeaderboardTrophy;
